import React, { ReactNode, ReactNodeArray } from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import WorldAndServicesSliderBlockData from '../../../Models/Content/WorldAndServicesSliderContentDataData';
import WorldAndServicesSlider from './WorldAndServicesSlider';

export default class NavSliderBlock extends EpiComponent<WorldAndServicesSliderBlockData> {

    public render(): ReactNode | ReactNodeArray | null {
        return (
            <>
                <div className={'world-and-services-slider'}>
                    <WorldAndServicesSlider iContent={this.props.data} context={this.getContext()} />
                </div>
            </>
        );
    }
}
